<template>
    <div class='slide'>
        <a class='row' style="display:flex" @click='onClickMenuItem()'>
          <div style="margin: auto">
            <div v-if='checkStringData(menuImage)' class='col col1'>
                <img class='thum' :src='menuImage'/>
            </div>
            <div class='col col2'>
                <p class='page'>
                    {{this.companyType == 5 ? $t('todaysShopping') : $t('todaysMenu')}} {{index + 1}}
                    <span class='num'>/ {{totalNo}}</span>
                </p>
                <p class='goodsTit'>
                    {{formatName(menu.name, 20)}}
                </p>
                <div class='price'>
                    <div :class='{box: disableOrderMenu}'>
                        <strong>{{formatComma(menu.price)}}</strong>
                        <span class='won'>{{$t('MoneyUnit')}}</span>
                    </div>
                    <span v-if='disableOrderMenu' class='tag'>{{$t(tag)}}</span>
                </div>
            </div>
          </div>
        </a>
    </div>
</template>
<script lang="js">
import { TODAY_MENU_ITEM } from '@/utils/EndPoint'
import { THROW_MENU } from '@/router/index'
import Vue from 'vue'
export default Vue.extend({
  name: TODAY_MENU_ITEM,
  props: [
    'menu', // 상품 정보
    'index', // 상품의 index 번호
    'totalNo' // 오늘의 상품 총 개수
  ],
  data () {
    return {
      companyType: this.$store.getters.companyType,
      menuImage: this.menu.imagePath, // 상품 이미지 썸네일
      disableOrderMenu: this.menu.soldOutTodayFlag || this.menu.outOfTimeFlag,
      tag: this.menu.soldOutTodayFlag ? 'soldOut' : '조리불가'
    }
  },
  methods: {
    onClickMenuItem () { THROW_MENU(this.menu.code) }
  }
})
</script>
